module.exports = __webpack_public_path__ + "img/958b4eb.webp";